import importExport from './import&export.vue'
import moment from 'moment'
export default {
  components: { importExport },
  methods: {
    importProduct() {
      this.$refs['importExport'].importProduct();
    },
    // 导出 --新接口
    onExport() {
      
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {  //办公平台
        taskDTO: {
          appCode: "ec-pc-api",
          // 数据过滤
          paramMap: {
            exportTag: true,
            ...this.formData
          },
          reportName: "saleNumListExport"
        },
        // 配置导出列
        columnDTOs: [
          // {
          //   columnName: '包件编码',
          //   parentColumnName: null,
          //   fieldName: 'packCode',
          //   fieldType: 'string',
          //   columnFormat: null
          // }
        ]
      };
      if(this.activeTable == 0) {
        this.$q.newProduct.categoryListExport({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          loading.close();
          let fileName = '大型号品类分布'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.XLSX`);
        });
      }else if(this.activeTable == 1) {
        this.$q.newProduct.bigModelSalesOverviewExport({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          loading.close();
          let fileName = '大型号销售定位概览'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.XLSX`);
         
        });
      }else if(this.activeTable == 2) {
        this.$q.newProduct.proTypeListExport({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          let fileName = '大型号产品类别概览'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.XLSX`);
          loading.close();
        });
      }else if(this.activeTable == 3) {
        this.$q.newProduct.productUnsoldListExport({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          let fileName = '产品滞销情况'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.XLSX`);
          loading.close();
        });
      }
      // 不导出图片列
      // params.columnDTOs = params.columnDTOs.filter(v=>v.columnName !== '图片');
      // this.$q.common.exportExcel({data: params}).then((res) => {
      //   console.log(res)
      //   loading.close();
      //   this.$message({
      //     type: "success",
      //     message: "导出成功,请在导出列表中查看",
      //   });
      // });
    },
  }
}